<template>
    <div id="calendar-queued">
        <h2><span>Unconfirmed</span></h2>

        <table class="calendar-queued-list table">
            <tr>
                <th class="calendar-queued-status">
                    <SortableHeader :active="'status' == key" :asc="ascending"
                        @click="doSortBy('status')"
                    ><CalendarIcon :force="ITEM_TYPES.QUEUED" /></SortableHeader>
                </th>
                <th>
                    <SortableHeader :active="'name' == key" :asc="ascending"
                        @click="doSortBy('name')"
                    >Name</SortableHeader>
                </th>
                <th>
                    <SortableHeader :active="'org' == key" :asc="ascending"
                        @click="doSortBy('org')"
                    >Organisation</SortableHeader>
                </th>
                <th v-if="hasSlots">
                    <SortableHeader :active="'slot' == key" :asc="ascending"
                        @click="doSortBy('slot')"
                    >Meeting time</SortableHeader>
                </th>
                <th>
                    <SortableHeader :active="'date' == key" :asc="ascending"
                        @click="doSortBy('date')"
                    >Sent</SortableHeader>
                </th>
            </tr>
            <tr v-for="(item, index) in sorted" :key="`item${index}`"
                class="calendar-queued-row"
                @click="doModal(item)"
            >
                <td class="calendar-queued-status">
                    <CalendarIcon :item="item" :me="me" />
                </td>
                <td>{{item.other_name}}</td>
                <td>{{item.other_organisation_name}}</td>
                <td v-if="hasSlots">{{asDateTimeStamp(item.startObj, timezone)}}</td>
                <td>{{asRelativeDateTime(item.created_at, true)}}</td>
            </tr>
        </table>
    
    </div>
</template>

<script>
/** Iterate through the list inserting LOCAL day boundaries as required.
 * These calendar items must all be SLOTLESS MEETINGS 
 * - so we need to work out the OTHER booker/attendee entries for ease of sorting.
 */
import {ITEM_TYPES} from '@/components/Config';

import SortableHeader from "@/components/table/SortableHeader";
import {asDateTimeStamp, asRelativeDateTime} from "@/utils/DateTime";
// import {isMeetingSlotless} from "@/utils/Filter";
import {compareBy} from "@/utils/Sort";

import CalendarIcon from './CalendarIcon';

const KEYS = {
    STATUS: 'status',
    NAME: 'name',
    ORG: 'org',
    SLOT: 'slot',
    DATE: 'date',
};

export default {
    name: "CalendarQueued",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    data: function() {
        return {
            key: KEYS.STATUS, // DEFAULT SORT ORDER
            ascending: true,
        };
    },
    components: {
        CalendarIcon,
        SortableHeader,
    },
    computed: {
        filtered() {
            // Re-filter the items to just show the slotless ones
            // return this.items.filter(item => isMeetingSlotless(item));
            return [
                ...this.filters.slotless,
                ...this.filters.inbound,
                ...this.filters.outbound
            ];
        },
        sorted() {
            let copied = [...this.filtered]; // .map(addOther(this.me));
            switch (this.key) {
                case KEYS.NAME:
                    // TODO: Sort by LAST name, not whole name :-/
                    // copied.sort(compareAttendeeName);
                    copied.sort(compareBy('other_last_name'));
                    break;
                case KEYS.ORG:
                    copied.sort(compareBy('other_organisation_name'));
                    break;
                case KEYS.SLOT:
                    copied.sort(compareBy('start_time')); // Is this the best sorting field?
                    break;
                case KEYS.DATE:
                    copied.sort(compareBy('created_at'));
                    break;
                case KEYS.STATUS:
                    copied.sort(compareBy('flags'));
            }
            if (!this.ascending) {
                copied.reverse();
            }
            return copied; // copied.map(addOther(this.me));
        },
        hasSlots() {
            return Boolean(this.filtered.find(item => Boolean(item.meeting_slot_id)));
        }
    },
    methods: {
        asDateTimeStamp,
        asRelativeDateTime,
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.sorted
            });
        },
        doSortBy(key) {
            if (this.key==key) {
                this.ascending = !this.ascending;
            } else {
                this.key = key
            }
        }
    },
    beforeCreate() {
        this.ITEM_TYPES = ITEM_TYPES;
    },
}
</script>

<style>
#calendar-queued {
    margin-bottom: 10px;
}

.calendar-queued-row {
    cursor: pointer;
}

/* Override some bootstrap defaults */
#calendar-queued .table th {
    border-top: 0;
    padding: 0;
}

</style>